import { InformationVariantCircleIcon } from './InformationVariantCircleIcon';

/**
 * author: Jeff Anders
 * id 5569AF9F-4D90-4D8B-91B3-EBBCFD5644AB
 * name information-variant-circle
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-variant-circle.svg
 * tags
 * - Settings 
 */
export const InfoSerifCircleIcon = InformationVariantCircleIcon;
export default InfoSerifCircleIcon